var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.27087H9.66667",
    stroke: "#A3B0B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.83337L6 1.00004",
    stroke: "#A3B0B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 6.27087H0.49998",
    stroke: "#A3B0B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20833 9.25L10.0995 10.1667C10.9704 9.19361 11.5 7.90865 11.5 6.5C11.5 3.46243 9.03757 1 6 1C2.96243 1 0.5 3.46243 0.5 6.5C0.5 7.90865 1.02956 9.19361 1.90047 10.1667L2.79167 9.25",
    stroke: "#A3B0B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35001 4.12938L6.45829 6.04162",
    stroke: "#A3B0B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.01236,
    cy: 6.48153,
    r: 0.645833,
    transform: "rotate(-44 6.01236 6.48153)",
    stroke: "#A3B0B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 2.375L8.74999 3.75",
    stroke: "#A3B0B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87502 2.37501L3.25001 3.75001",
    stroke: "#A3B0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.1edfc45788eb0263a3ac1e6889c2a05e.svg";
export { ForwardRef as ReactComponent };